import { iso8601DurationToDays } from './iso8601DurationToDays';
import { iso8601DurationToMonths } from './iso8601DurationToMonths';

// ISO 8601 DURATION - "P1M"
export const getTermByPeriod = (termUnit: 'day' | 'month', value: string) => {
  return termUnit === 'day' ? iso8601DurationToDays(value) : iso8601DurationToMonths(value);
};
